module.exports = __webpack_public_path__ + "img/leads.35276b5f.svg";